module.exports = __webpack_public_path__ + "img/ES0078.76b17562.png";